import React from "react";
import { Link } from "gatsby";
import { navigate } from "gatsby";
import range from "lodash.range";
var Pagination = function Pagination(_ref) {
    var currentPage = _ref.currentPage, pageCount = _ref.pageCount, basePath = _ref.basePath;
    var prevIndex = currentPage - 1 > 0 ? currentPage - 1 : "";
    var navigateToPage = function navigateToPage(event) {
        var val = event.currentTarget.valueAsNumber;
        if (event.key === "Enter" && val && val >= 1 && val <= pageCount) {
            navigate("/" + basePath + "/" + (val - 1 || ""));
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "p-6 text-2xl flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center mr-10"
    }, /*#__PURE__*/ React.createElement("span", null, "Seite"), /*#__PURE__*/ React.createElement("input", {
        type: "number",
        defaultValue: currentPage + 1,
        onKeyPress: navigateToPage,
        min: "1",
        max: pageCount,
        className: "hidden lg:block h-full w-16 text-center border border-solid border-gray-300 rounded pt-1 mx-2"
    }), /*#__PURE__*/ React.createElement("select", {
        defaultValue: currentPage,
        onChange: function onChange(e) {
            return navigate("/" + basePath + "/" + (parseInt(e.target.value) || ""));
        },
        className: "lg:hidden border border-solid border-gray-300 rounded pt-1 mx-2"
    }, range(pageCount).map(function (page) {
        return /*#__PURE__*/ React.createElement("option", {
            value: page,
            key: page
        }, page + 1);
    })), /*#__PURE__*/ React.createElement("span", {
        className: "flex-shrink-0"
    }, "von ", pageCount)), /*#__PURE__*/ React.createElement("div", {
        className: "flex h-12 py-1"
    }, currentPage > 0 && /*#__PURE__*/ React.createElement(Link, {
        to: "/" + basePath + "/" + prevIndex,
        title: "Zur\xFCck",
        className: "flex items-center justify-center w-8 bg-gray-200 hover:bg-gray-300"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "h-6 leading-8"
    }, "<")), currentPage < pageCount - 1 && /*#__PURE__*/ React.createElement(Link, {
        to: "/" + basePath + "/" + (currentPage + 1),
        title: "Weiter",
        className: "flex items-center justify-center w-8 bg-gray-200 hover:bg-gray-300 ml-2"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "h-6 leading-8"
    }, ">"))));
};
export default Pagination;
